import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { TypeUtils } from "../../shared/utilities/typeUtils";

export interface IReviewWidgetOptionBase extends IInstanceComponentBase {
    rating: number;
    isDisabled: boolean;
    isSelected: boolean;
}

export abstract class ReviewWidgetOptionBase extends InstanceComponentBase implements IReviewWidgetOptionBase {
    public rating: number; 
    private readonly _handleOptionClick;

    constructor(public htmlElement: HTMLElement, public isDisabled: boolean, public isSelected: boolean) {
        super(htmlElement);

        this._handleOptionClick = this.handleOptionClick.bind(this);

        this.setRating();
        
        this.updateIsDisabled(isDisabled);
        this.attachOptionClickEventListener();
    }
    abstract updateIsSelected(isSelected: boolean): void;

    attachOptionClickEventListener() {
        console.log('ReviewWidgetOptionBase: attachOptionClickEventListener');
        this.htmlElement.addEventListener('click', this._handleOptionClick);
    }
    removeOptionClickEventListener() {
        console.log('ReviewWidgetOptionBase: removeRatingsOptionClickEventListener');
        this.htmlElement.removeEventListener('click', this._handleOptionClick);
    }

    handleOptionClick(e: Event) {
        console.log('ReviewWidgetOptionBase: handleOptionClick');

        this.htmlElement.dispatchEvent(this.optionCustomEvent(this.rating, this.isDisabled, this.isSelected));
    }

    optionCustomEvent(rating: number, isDisabled: boolean, isSelected: boolean) {
        console.log(`ReviewWidgetOptionBase: optionCustomEvent rating: ${rating}  isDisabled: ${isDisabled}`);
        return new CustomEvent(CustomEventEnums.ReviewWidgetOptionSelected, {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
                'rating': rating,
                'isDisabled': isDisabled,
                'isSelected' : isSelected
            }
        });
    }
 
    setRating(): void {
        this.rating = +this.htmlElement.getAttribute(AttributeEnums.ReviewWidgetRatingsOption.ratingsOptionRating);
    }

    updateIsDisabled(isDisabled: boolean):void{
            this.isDisabled = isDisabled;
            this.setDisabledCssClass();
            this.setDisabledAriaState();
    }
   
    setDisabledCssClass():void{
        console.log(`ReviewWidgetOptionBase: setDisabledCssClass - ${this.isDisabled}`);
        if(this.isDisabled){
            this.htmlElement.classList.add(StringEnums.CssClass.LbDisabled);
        }else{
            this.htmlElement.classList.remove(StringEnums.CssClass.LbDisabled);
        }
    }
    setDisabledAriaState():void{
        console.log(`ReviewWidgetOptionBase: setDisabledAriaState - ${this.isDisabled}`);
        this.htmlElement.setAttribute('aria-disabled', this.isDisabled.toString());
    }

    dispose(): void {
        try {
            console.log(`ReviewWidgetOptionBase: dispose`);
            
            this.removeOptionClickEventListener();
        } catch (error) {
            console.log('ReviewWidgetOptionBase: dispose ERROR', error);
        }
    }
}